<template>
  <div class="error-message center">
    <div class="error-image"><img src="@/assets/sad-bird.svg"/></div>
    <div class="error-title"><h2>{{ $t('error-title') }}</h2></div>
    <div class="error-text">{{ message || $t('error-text') }}</div>
    <div class="error-button"><button class="button button-lg" @click="back">Terug</button></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    back() {
      this.$router.back();
      window.history.back();
    }
  },
  props: ['message'],
};
</script>

<style scoped>
  .error-image {
    width: 25%;
    max-width: 200px;
    margin: 0 auto;
  }

  .error-image img {
    max-width: 100%;
  }

  .error-button {
    margin-top: 40px;
  }

  .error-title {
    padding-top: 20px;
    color: #3D70FF;
    color: var(--primary-color);
  }
</style>



// WEBPACK FOOTER //
// src/components/ErrorMessage.vue